<template>
  <div>
    <h1 style="margin: 0 0 4px">National DPE Contact Form</h1>
    <div class="input-group subject-line">
      <div class="input-label-container">
        <label for="subjectLine">Subject Line:</label>
        <input type="text" id="subjectLine" v-model="subjectLine" />
      </div>
    </div>
    <div class="checkbox-group-container">
      <p class="checkbox-group-label">Select Checkride</p>
      <div class="checkbox-group">
        <label
          v-for="option in checkrideOptions"
          :key="option"
          class="checkbox-option"
        >
          <input type="checkbox" v-model="selectedCheckrides" :value="option" />
          {{ option }}
        </label>
        <div class="checkbox-links">
          <a href="#" @click.prevent="selectAll">All</a>
          <a href="#" @click.prevent="deselectAll">None</a>
        </div>
      </div>
    </div>
    <div class="input-group checkride-date">
      <div class="input-label-container">
        <label for="checkrideDate">Requested Check Ride Date:</label>
        <input type="date" id="checkrideDate" v-model="checkrideDate" />
      </div>
    </div>
    <h1>Edit Email Template</h1>
    <textarea
      v-model="emailTemplate"
      rows="10"
      class="email-template-textarea"
    ></textarea>
    <div class="setup-input-group">
      <div class="setup-input-label-container">
        <label for="sentBy">Sent by:</label>
        <input type="text" id="sentBy" v-model="sentBy" />
        <label for="sentDate" class="right-label">Date:</label>
        <input
          type="date"
          id="sentDate"
          v-model="sentDate"
          class="right-input"
        />
      </div>
    </div>
    <div class="action-button-container">
      <button class="action-button">Send</button>
    </div>
    <coming-soon-modal />
  </div>
</template>

<script>
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";

export default {
  components: { ComingSoonModal },
  data() {
    return {
      subjectLine: "DPE Checkride Request",
      checkrideOptions: [
        "Private",
        "Commercial",
        "Instrument",
        "Multi",
        "CFI",
        "CFII",
      ],
      selectedCheckrides: [],
      checkrideDate: "",
      emailTemplate: `Dear [DPE Name],

I hope this email finds you well. I am writing to request a check ride for the following:

- Checkride Type: [Selected Checkride]
- Requested Date: [Requested Check Ride Date]

Please let me know your availability and if there are any additional details or documents required.

Thank you for your time and consideration.

Best regards,
[Your Name]
[Your Contact Information]`,
      sentBy: "Tyler Johnson",
      sentDate: new Date().toISOString().split("T")[0],
    };
  },
  watch: {
    selectedCheckrides() {
      this.updateEmailTemplate();
    },
    checkrideDate() {
      this.updateEmailTemplate();
    },
  },
  methods: {
    selectAll() {
      this.selectedCheckrides = [...this.checkrideOptions];
    },
    deselectAll() {
      this.selectedCheckrides = [];
    },
    formatDate(date) {
      if (!date) return "[Requested Check Ride Date]";
      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    updateEmailTemplate() {
      const selectedCheckridesString =
        this.selectedCheckrides.join(", ") || "[Selected Checkride]";
      this.emailTemplate = `Dear [DPE Name],

I hope this email finds you well. I am writing to request a check ride for the following:

- Checkride Type: ${selectedCheckridesString}
- Requested Date: ${this.formatDate(this.checkrideDate)}

Please let me know your availability and if there are any additional details or documents required.

Thank you for your time and consideration.

Best regards,
[Your Name]
[Your Contact Information]`;
    },
  },
};
</script>

<style scoped>
.input-group {
  display: flex;
  flex-direction: column;
  background-color: #f0f0f0;
  padding: 2px 10px;
  border-radius: 8px;
  width: 50%;
  margin-top: 20px;
  position: relative;
  border: 1px solid #ccc;
}

.input-label-container {
  display: flex;
  align-items: center;
  position: relative;
  background-color: #f0f0f0;
  border-radius: 8px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 50%;
}

.input-label-container label {
  font-size: 14px;
  position: absolute;
  left: 2px;
  margin-top: 1px;
  padding-top: 7px;
  font-weight: normal;
  background-color: #f0f0f0;
}

.input-label-container input {
  padding: 4px;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  background-color: #f0f0f0;
  height: 31px;
  width: 100%;
}

.checkbox-group-container {
  margin-top: 20px;
}

.checkbox-group-label {
  font-size: 14px;
  color: black;
  margin-bottom: 10px;
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.checkbox-option {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 14px;
}

.checkbox-option input[type="checkbox"] {
  appearance: none;
  width: 18px;
  height: 18px;
  border: 1px solid #ccc;
  margin-right: 8px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.checkbox-option input[type="checkbox"]:checked::before {
  content: "";
  width: 14px;
  height: 14px;
  background-color: black;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.checkbox-links {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 10px;
}

.checkbox-links a {
  margin-right: 30px;
  cursor: pointer;
  color: black;
  text-decoration: none;
  font-size: 14px;
}

.checkbox-links a:hover {
  text-decoration: none;
}

.email-template-textarea {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #ccc;
  background-color: #f0f0f0;
  resize: vertical;
}

.setup-input-group {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f0f0f0;
  padding: 8px 4px 0;
  margin: 20px 0 10px;
  height: 36px;
  width: 50%;
}

.setup-input-label-container {
  display: flex;
  align-items: center;
  position: relative;
  background-color: #f0f0f0;
  border-radius: 8px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.setup-input-group .setup-input-label-container {
  display: flex;
  align-items: center;
  position: relative;
}

.setup-input-group .setup-input-label-container label {
  font-size: 14px;
  position: absolute;
  padding: 0 4px;
  background-color: #f0f0f0;
}

.setup-input-group .setup-input-label-container .right-label {
  left: 50%;
  transform: translateX(-50%);
}

.setup-input-group .setup-input-label-container input {
  padding: 0 4px 6px 100px;
  font-size: 14px;
  background-color: #f0f0f0;
  height: 20px;
  width: calc(50% - 50px);
  border: none;
}

.setup-input-group .setup-input-label-container .right-input {
  width: calc(50% - 50px);
  height: 100%;
  padding: 0 4px 6px 40px;
  box-sizing: border-box;
  position: absolute;
  right: 0;
}

.action-button-container {
  margin-top: 20px;
  display: flex;
  gap: 10px;
}

.action-button {
  padding: 0 26px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.action-button:hover {
  background-color: #333;
}
</style>
